import {CONFIG} from "../../config";
import axios from "axios";

async function GetUsersQuery() {
    const location = CONFIG.API_URL + "user/get";
    const settings = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('bearer-token')}`,
        }
    };

    try {
        return await axios.get(location, settings);
    } catch (e) {
        return e;
    }
}

export default GetUsersQuery;